import { render, staticRenderFns } from "./UpdateStatusUnimportant.vue?vue&type=template&id=3c602248&"
import script from "./UpdateStatusUnimportant.vue?vue&type=script&lang=js&"
export * from "./UpdateStatusUnimportant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports